import React from "react";
import HeroSection from "../Landing-page/Hero_section";
import Section2 from "../Landing-page/Section2";
import Section3 from "../Landing-page/Section3";
import Section4 from "../Landing-page/Section4";
import Section5 from "../Landing-page/Section5";
import Section6 from "../Landing-page/Section6";
import Section7 from "../Landing-page/Section7";
import Section8 from "../Landing-page/Section8";

const HomePage = () => {
  return (
    <div>
      <HeroSection />
      <Section2 />
      <Section3 />
      <Section4 />
      <Section5 />
      <Section6 />
      <Section8 />
      <Section7 />
    </div>
  );
};

export default HomePage;
